<template>
  <div class="container">
    <section class="project">
      <NavigationBar />
      <h1 class="project__title">
        {{ project.name }}
      </h1>
      <div class="project__details">
        <img
          class="project__image"
          :src="require(`@/assets/${project.image}`)"
          :alt="project.name"
        />
        <p class="project__description">{{ project.description }}</p>
      </div>
      <ProjectDetail
        v-for="(detail, index) in project.details"
        :key="index"
        :name="detail.name"
        :description="detail.description"
        :image="detail.image"
      />
    </section>
  </div>
</template>
<script>
import store from "@/store";
import NavigationBar from "@/components/NavigationBar";
import ProjectDetail from "@/components/ProjectDetail.vue";

export default {
  components: {
    ProjectDetail,
    NavigationBar,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  computed: {
    project() {
      return store.projects.find((project) => project.slug === this.slug);
    },
  },
};
</script>

<style scoped>
.project {
  margin-top: 64px;
  margin-bottom: 64px;
}
.project__title {
  font-size: 64px;
  margin-top: 32px;
  margin-bottom: 32px;
}
.project__details {
}

.project__description {
  font-size: 24px;
  margin-bottom: 32px;
}

.project__image {
  width: 100%;
  height: auto;
}
</style>
